import Papa from 'papaparse';
import { downloadCSV } from '../../../../utils/utils';

const TEMPLATE_FILENAME = 'RingGroupMembershipTemplate.csv';

// Blank template row with the columns this flow expects.
// 'Ring Group Name' must match an existing Ring Group's Name exactly.
// 'Member UPN' must match an existing 8x8 platform user's UPN exactly.
// 'Action' accepts 'Add' or 'Remove'.
//
// Unlike the Users/Create CSV templates, this template does not pre-populate
// existing membership data (that would require one getRingGroupMembers call
// per Ring Group in the company) — it is a static header-only template with
// one example row, since Add/Remove is already explicit per-row.
const TEMPLATE_ROW = {
    'Ring Group Name': '',
    'Member UPN': '',
    Action: '',
};

export default function useCSVRingGroupMembershipTemplate() {
    const handleDownloadTemplate = () => {
        const res = Papa.unparse([TEMPLATE_ROW]);
        downloadCSV(res, TEMPLATE_FILENAME);
    };

    return {
        handleDownloadTemplate,
        loading: false,
        error: false,
    };
}
